import { render, staticRenderFns } from "./select-service.vue?vue&type=template&id=ba953906"
import script from "./select-service.vue?vue&type=script&lang=js"
export * from "./select-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports